import { MilestoneIcon } from "lucide-react";
import Upload from "../utils/Upload";
import Button from "../utils/Button";
import { collapseIcon, expandIcon, milestoneTitleIcon } from "../utils/svg";
import { useEffect, useRef, useState } from "react";
import { Modal } from "../utils/Modal";
import apiCall from "../network/api";
import { useLocation, useNavigate } from "react-router-dom";
import { SMARTSHEET_URL } from "../network/config";
import InputwithLabelandError from "../utils/InputwithLabelandError";
import Accordion from "../utils/Accordian";
import { MAX_RETRIES, MILESTONE_RETRY_TIME } from "../utils/constants";
import { MileStoneModal } from "../utils/MileStoneModal";
import { capitalizeFirstLetter } from "../utils/genericFunctions";
import SignaturePad from "signature_pad";

export const Milestone = ({
  overviewData,
  selectedAogMilestoneObject,
  handleSubmit,
  submitLoading,
  setStatus,
  setSubmitLoading,
  setLoading,
  setIsLocation,
  coordRef,
  sendMilesStoneUpdateEmail,
  setOverviewData,
  emailStatus,
  setEmailStatus,
  submitStatus,
  setSubmitStatus,
  emailAttempts,
  setEmailAttempts,
  submitAttempts,
  setSubmitAttempts,
  isGround,
  userEmail,
  setFetchLatestData,
}) => {
  const [selectedImage, setSelectedImage] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(
    overviewData?.stages?.[0]?.milestones.filter(
      (milestone) =>
        milestone.status === "completed" || milestone.status === "skipped",
    )?.length >= selectedAogMilestoneObject?.length,
  );

  const [note, setNote] = useState("");
  const [isNoteValid, setIsNoteValid] = useState(true);

  const [isSuccess, setIsSuccess] = useState(
    overviewData?.stages?.[0]?.milestones.filter(
      (milestone) =>
        milestone.status === "completed" || milestone.status === "skipped",
    )?.length >= selectedAogMilestoneObject?.length,
  );
  const [newOverviewData, setNewOverviewData] = useState();
  const [smartSheetLinks, setSmartSheetLinks] = useState([]);
  const [podFirstName, setPodFirstName] = useState("");
  const [podLastName, setPodLastName] = useState("");
  const [podCompanyName, setPodCompanyName] = useState("");
  const [isFirstNameValid, setIsFirstNameValid] = useState(true);
  const [isLastNameValid, setIsLastNameValid] = useState(true);
  const [isCompanyNameValid, setIsCompanyNameValid] = useState(true);
  const [fileUploads, setFileUploads] = useState([]);
  const [skipped, setSkipped] = useState(false);

  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);
  const [signatureUploadStatus, setSignatureUploadStatus] = useState("idle");
  const [signatureDetails, setSignatureDetails] = useState({
    name: "",
    key: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if ("geolocation" in navigator) {
      // Try to get the user's location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Successfully got the location
          setIsLocation(true);
          coordRef.current = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
        },
        (error) => {
          // Error occurred, likely due to permission denied or other issues
          setIsLocation(false);
        },
      );
    } else {
      setIsLocation(false);
    }
  });

  useEffect(() => {
    setNote("");
  }, [location.search]);

  useEffect(() => {
    setPodFirstName(overviewData?.stages?.[0]?.pod?.first_name || "");
    setPodLastName(overviewData?.stages?.[0]?.pod?.last_name || "");
    setPodCompanyName(overviewData?.stages?.[0]?.pod?.company || "");
  }, [overviewData]);

  const currentStep =
    overviewData?.stages?.[0]?.milestones?.filter(
      (milestone) =>
        milestone.status === "completed" || milestone.status === "skipped",
    )?.length || 0;

  useEffect(() => {
    const isPodMilestone = selectedAogMilestoneObject?.[currentStep]?.is_pod;
    const canvas = canvasRef.current;

    if (!isPodMilestone || !canvas) return undefined;

    const resizeCanvas = () => {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const width = canvas.offsetWidth || 320;
      const height = 180;

      canvas.width = width * ratio;
      canvas.height = height * ratio;
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;

      const context = canvas.getContext("2d");

      if (context) {
        context.scale(ratio, ratio);
      }

      const signaturePad = signaturePadRef.current;

      if (signaturePad) {
        signaturePad.clear();
      }
    };

    const signaturePad = new SignaturePad(canvas, {
      minWidth: 1,
      maxWidth: 2.5,
      penColor: "#111827",
      backgroundColor: "rgb(255,255,255)",
    });

    signaturePadRef.current = signaturePad;
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    return () => {
      window.removeEventListener("resize", resizeCanvas);
      signaturePad.off();
      signaturePadRef.current = null;
    };
  }, [currentStep, selectedAogMilestoneObject]);

  useEffect(() => {
    handleDownloadUrls();
    setIsModalOpen(
      overviewData?.stages?.[0]?.milestones.filter(
        (milestone) =>
          milestone.status === "completed" || milestone.status === "skipped",
      )?.length >= selectedAogMilestoneObject?.length ||
        (currentStep >= 1 &&
          overviewData?.stages?.[0]?.milestones?.[currentStep].phase !==
            overviewData?.stages?.[0]?.milestones?.[currentStep - 1].phase),
    );
    setIsSuccess(
      overviewData?.stages?.[0]?.milestones.filter(
        (milestone) =>
          milestone.status === "completed" || milestone.status === "skipped",
      )?.length >= selectedAogMilestoneObject?.length ||
        (currentStep >= 1 &&
          overviewData?.stages?.[0]?.milestones?.[currentStep].phase !==
            overviewData?.stages?.[0]?.milestones?.[currentStep - 1].phase),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overviewData?.stages?.[0]?.milestones, selectedAogMilestoneObject]);

  const filterByFolder = (data, folder) => {
    return [
      ...data.filter((item) => item.name.includes(`/${folder}/`)),
      ...selectedImage?.filter((file) => file.step === folder),
    ];
  };

  useEffect(() => {
    const signatureFiles = filterByFolder(
      selectedImage || [],
      `m${currentStep + 1}_pod_signature`
    );

    if (signatureFiles?.length > 0) {
      const latestSignature =
        signatureFiles[signatureFiles.length - 1]?.name?.split("/")?.pop() ||
        "pod_signature.png";

      setSignatureDetails({
        name: decodeURIComponent(latestSignature),
        key: signatureFiles[signatureFiles.length - 1]?.name || "",
      });
      setSignatureUploadStatus("completed");
    }
  }, [currentStep, selectedImage]);

  const isDisabled = () => {
    // 1️. Disable if any upload is still loading
    if (fileUploads?.some((file) => file?.uploaded === "loading")) {
      return true;
    }

    const milestone = selectedAogMilestoneObject?.[currentStep];
    if (!milestone) return false;

    // 2️. OBC remark check
    if (
      milestone?.obc_remark === "mandatory" &&
      (!note || note.trim().length === 0)
    ) {
      return true;
    }

    // 3️. POD name validation
    if (milestone?.is_pod) {
      const hasSavedSignature = !!signatureDetails?.key;
      const hasDrawnSignature = !!(
        signaturePadRef.current && !signaturePadRef.current.isEmpty()
      );
      const podValid =
        podFirstName?.trim()?.length > 0 &&
        isFirstNameValid &&
        podLastName?.trim()?.length > 0 &&
        isLastNameValid &&
        podCompanyName?.trim()?.length > 0 &&
        isCompanyNameValid &&
        (hasSavedSignature || hasDrawnSignature) &&
        signatureUploadStatus !== "loading";

      if (!podValid) return true;
    }

    // 4️. Mandatory document validation
    if (Array.isArray(milestone?.documents) && milestone.documents.length > 0) {
      const allMandatoryDocsUploaded = milestone.documents.every(
        (doc, index) => {
          if (!doc?.is_mandatory) return true;

          const folder = `m${currentStep + 1}_${index}`;
          const uploadedDocs = filterByFolder(selectedImage || [], folder);

          return uploadedDocs?.length > 0;
        },
      );
      if (!allMandatoryDocsUploaded) return true;
    }

    return false;
  };

  const getDownloadUrls = async (folderName) => {
    try {
      const result = await apiCall({
        endpoint: "/generate-download-urls",
        method: "POST",
        data: JSON.stringify({ folderName }),
      }).then((data) => {
        setSelectedImage([...data]);
        setSmartSheetLinks([
          ...data?.map((res) => SMARTSHEET_URL + "/" + res?.name),
        ]);
        return data;
      });
      return result;
    } catch (err) {
      // setError(err);
      if (err?.status === 403) {
        localStorage.clear();
        navigate("/login");
      }
    }
  };

  const getDownloadAllUrls = async (folderName) => {
    try {
      const result = await apiCall({
        endpoint: "/generate-download-urls",
        method: "POST",
        data: JSON.stringify({ folderName }),
      });

      const groupedData = {};

      result.forEach((item) => {
        const parts = item.name.split("/");

        const subfolder = parts[1]; // m1_0
        const [milestone, docIndex] = subfolder.replace("m", "").split("_");

        if (!groupedData[milestone]) groupedData[milestone] = {};
        if (!groupedData[milestone][docIndex])
          groupedData[milestone][docIndex] = [];

        groupedData[milestone][docIndex].push(`${SMARTSHEET_URL}/${item.name}`);
      });

      return groupedData;
    } catch (err) {
      if (err?.status === 403) {
        localStorage.clear();
        navigate("/login");
      }
    }
  };

  const getPresignedUrl = async (folderName, subFolderName, fileName, fileType) => {
    try {
      const result = await apiCall({
        endpoint: "/generate-presigned-url",
        method: "POST",
        data: JSON.stringify({ folderName, subFolderName, fileName, fileType }),
      });

      return result?.url;
    } catch (err) {
      if (err?.status === 403) {
        localStorage.clear();
        navigate("/login");
      }
      throw err;
    }
  };

  const clearSignature = () => {
    signaturePadRef.current?.clear();
  };

  const deleteSignatureFile = async () => {
    if (!signatureDetails?.key) return;

    try {
      await apiCall({
        endpoint: "/delete-file",
        method: "DELETE",
        data: JSON.stringify({
          fileName: signatureDetails.key,
        }),
      });
    } catch (error) {
      console.error("Error deleting signature:", error);
    } finally {
      setSelectedImage((prev) =>
        prev.filter((file) => file.name !== signatureDetails.key)
      );
      setSignatureUploadStatus("idle");
      setSignatureDetails({ name: "", key: "" });
    }
  };

  const uploadSignature = async () => {
    const signaturePad = signaturePadRef.current;

    if (!signaturePad || signaturePad.isEmpty()) {
      return false;
    }

    try {
      setSignatureUploadStatus("loading");

      const dataUrl = signaturePad.toDataURL("image/png");
      const blob = await (await fetch(dataUrl)).blob();
      const fileName = "pod_signature.png";
      const subFolderName = `m${currentStep + 1}_pod_signature`;
      const folderName = encodeURIComponent(overviewData?.uniqueId);

      const url = await getPresignedUrl(
        folderName,
        subFolderName,
        encodeURIComponent(fileName),
        "image/png"
      );

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "image/png",
        },
        body: blob,
      });

      if (!response.ok) {
        throw new Error("Failed to upload signature");
      }

      setSignatureDetails({
        name: fileName,
        key: `${folderName}/${subFolderName}/${encodeURIComponent(fileName)}`,
      });
      setSignatureUploadStatus("completed");
      return true;
    } catch (error) {
      console.error("Error uploading signature:", error);
      setSignatureUploadStatus("failed");
      return false;
    }
  };
  const handleDownloadUrls = async () => {
    const urls = await getDownloadUrls(
      `${encodeURIComponent(overviewData?.uniqueId)}/m${currentStep + 1}_`,
    );

    return urls;
  };

  const [cooldownTime, setCooldownTime] = useState(0);
  const [isCooldownActive, setIsCooldownActive] = useState(false);

  useEffect(() => {
    if (submitStatus === "success" && emailStatus === "success") {
      moveToNextMilestone(newOverviewData, emailStatus, submitStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitStatus, emailStatus]);

  useEffect(() => {
    if (isCooldownActive && cooldownTime > 0) {
      const interval = setInterval(() => {
        setCooldownTime((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (cooldownTime === 0 && isCooldownActive) {
      setIsCooldownActive(false);
      setSubmitAttempts(0); //  Reset submit attempts
      setEmailAttempts(0); //  Reset email attempts
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cooldownTime, isCooldownActive]);

  const startCooldown = () => {
    setCooldownTime(MILESTONE_RETRY_TIME); // Start 5-minute cooldown (300 seconds)
    setIsCooldownActive(true);
  };

  // Generic retry function
  const retryApiCall = async (apiFunction, args, setStatus, setAttempts) => {
    try {
      setStatus("in-progress"); //  Show as "in-progress" before retrying

      const result = await apiFunction(args);

      if (result) {
        setStatus("success"); //  Mark as successful if API succeeds
        return result;
      }
    } catch (err) {
      console.error(`Retry failed.`);

      setAttempts((prev) => {
        const newAttempts = prev + 1;

        if (newAttempts >= MAX_RETRIES) {
          if (
            submitStatus === "success" &&
            emailStatus === "failed" &&
            newAttempts >= MAX_RETRIES
          ) {
            setIsModalOpen(false);
            setSubmitLoading(false);
            setafterAPIUpdatesModal(true);
          } else startCooldown(); //  Start cooldown after max retries
        }

        return newAttempts;
      });

      setStatus("failed"); //  Mark as failed after retry
      return null;
    }
  };

  const [afterAPIUpdatesModal, setafterAPIUpdatesModal] = useState(false);

  const moveToNextMilestone = (updatedData, submitStatus, emailStatus) => {
    if (!updatedData) {
      console.error("No data received, cannot navigate.");
      return;
    }

    setNote("");

    setOverviewData(updatedData?.data);

    setIsModalOpen(false);
    setSubmitLoading(false);
    setafterAPIUpdatesModal(false);

    setEmailStatus("disabled");
    setSubmitStatus("disabled");
    setEmailAttempts(0);
    setSubmitAttempts(0);

    setTimeout(() => {
      const milestonePath = `/home/${
        updatedData?.data[0]?.uniqueId
      }/milestone?m=${currentStep + 2}`;

      navigate(milestonePath);
    }, 500); //  Delay for state updates
  };

  const retrySubmission = async (type) => {
    if (type === "submit") {
      await handleSubmitMilestone();
    } else if (type === "email") {
      await handleSendEmail(newOverviewData); // Pass the latest data
    }
  };

  const handleSubmitMilestone = async (isSkipped) => {
    setSubmitStatus("in-progress");

    try {
      // Step 1: Fetch attachments
      const data = await getDownloadAllUrls(
        `${encodeURIComponent(overviewData?.uniqueId)}/`,
      );

      const isCustomsCleared =
        selectedAogMilestoneObject?.[currentStep]?.is_custom;
      // Step 2: Prepare update data
      const updateData = {
        numOfAttempts: submitAttempts,
        assignmentId: overviewData?.uniqueId,

        updateData: {
          stageData: {
            location_updates: [
              ...overviewData?.stages?.[0]?.location_updates,
              {
                milestone:
                  selectedAogMilestoneObject?.[currentStep]?.milestone_text,
                location: `https://www.google.com/maps?q=${coordRef.current?.latitude}%2C${coordRef.current?.longitude}`,
              },
            ],

            milestones: overviewData?.stages?.[0]?.milestones?.map(
              (milestone, index) =>
                index === currentStep + 1
                  ? {
                      ...milestone,
                      status: "in-progress",
                    }
                  : index === currentStep
                    ? {
                        ...milestone,
                        status: isSkipped ? "skipped" : "completed",
                        completed_at: new Date().toUTCString(),
                        completed_by: "",
                        location: `https://www.google.com/maps?q=${coordRef.current?.latitude}%2C${coordRef.current?.longitude}`,
                        documents: milestone.documents.map((doc, docIndex) => ({
                          ...doc,
                          document_url:
                            data?.[currentStep + 1]?.[docIndex] || [],
                        })),
                      }
                    : milestone,
            ),
            pod: {
              first_name: podFirstName !== "" ? podFirstName : null,
              last_name: podLastName !== "" ? podLastName : null,
              company: podCompanyName !== "" ? podCompanyName : null,
              completed: !!(
                podFirstName ||
                podLastName ||
                podCompanyName
              ),
            },
          },
          last_updated_by: userEmail,

          customs: {
            ...overviewData?.customs,
            clear_date: isCustomsCleared ? new Date().toUTCString() : null,
            clear_time: isCustomsCleared
              ? new Date().toISOString().split("T")[1].split(".")[0]
              : "",
          },
        },
      };

      // Step 3: Submit data update
      const newData = await retryApiCall(
        handleSubmit, //  Only submits milestone
        updateData,
        setSubmitStatus,
        setSubmitAttempts,
      );

      if (!newData) return null;

      setNewOverviewData(newData);
      setSubmitStatus("success");
      return newData;
    } catch (err) {
      console.error("Error in handleSubmitMilestone:", err);
      setSubmitStatus("failed");
    }
  };

  const handleSendEmail = async (updatedData) => {
    setEmailStatus("in-progress");

    const attachmentsURLs = await getDownloadAllUrls(
      `${encodeURIComponent(overviewData?.uniqueId)}/`,
    );

    try {
      const emailResult = await retryApiCall(
        sendMilesStoneUpdateEmail,
        {
          numOfAttempts: emailAttempts,
          obc_assigned: userEmail,
          emailData: {
            customerName: overviewData?.customer_id?.name,
            status: selectedAogMilestoneObject?.[currentStep]?.phase,

            title: selectedAogMilestoneObject?.[currentStep]?.milestone_text,

            description:
              selectedAogMilestoneObject?.[currentStep]?.email_description,

            currentTime: new Date().toUTCString(),
            currentMilestoneNumber: currentStep + 1,
            assignmentId: overviewData?.uniqueId,
            previousMilestones: overviewData?.stages?.[0]?.milestones?.filter(
              (milestone) => milestone.status === "completed",
            ),
            emailTo: overviewData?.customer_id?.updateEmailPrimary,
            emailCc: overviewData?.customer_id?.updateEmailSecondary?.join(","),
            emailBcc: overviewData?.customer_id?.updateEmailOthers,
            is_pod: selectedAogMilestoneObject?.[currentStep]?.is_pod,
            podFirstName:
              updatedData?.data?.[0]?.stages?.[0]?.pod?.first_name ||
              overviewData?.stages?.[0]?.pod?.first_name,
            podLastName:
              updatedData?.data?.[0]?.stages?.[0]?.pod?.last_name ||
              overviewData?.stages?.[0]?.pod?.last_name,
            podCompanyName:
              updatedData?.data?.[0]?.stages?.[0]?.pod?.company ||
              overviewData?.stages?.[0]?.pod?.company,
            attachments: attachmentsURLs,
            totalMilestones: selectedAogMilestoneObject?.length,
          },
        },
        setEmailStatus,
        setEmailAttempts,
      );

      if (!emailResult) return null;

      setEmailStatus("success");
      return updatedData;
    } catch (err) {
      console.error("Error in handleSendEmail:", err);
      setEmailStatus("failed");
    }
  };

  const handleMilestoneDataAndEmailSubmission = async (isSkipped) => {
    try {
      setSubmitLoading(true);
      setSkipped(isSkipped);

      if (
        !isSkipped &&
        selectedAogMilestoneObject?.[currentStep]?.is_pod &&
        !signatureDetails?.key
      ) {
        const signatureUploaded = await uploadSignature();
        if (!signatureUploaded) {
          setSubmitLoading(false);
          return;
        }
      }

      // Step 1: Handle Milestone Submission
      const updatedData = await handleSubmitMilestone(isSkipped);
      if (!updatedData) return;

      // Step 2: Send Email (only if not skipped)
      let emailData = null;

      if (!isSkipped) {
        emailData = await handleSendEmail(updatedData);
        if (!emailData) return;
      }

      // Step 3: Decide Next Steps
      const currentPhase = selectedAogMilestoneObject?.[currentStep]?.phase;
      const nextPhase = selectedAogMilestoneObject?.[currentStep + 1]?.phase;

      if (currentPhase !== nextPhase) {
        // Use whichever data is available
        setOverviewData(emailData?.data || updatedData?.data);

        setSubmitLoading(false);
        setSkipped(false);
        setafterAPIUpdatesModal(false);

        setEmailStatus("disabled");
        setSubmitStatus("disabled");
        setEmailAttempts(0);
        setSubmitAttempts(0);

        setIsSuccess(true);
      } else {
        moveToNextMilestone(
          emailData || updatedData,
          submitStatus,
          emailStatus,
        );
      }
    } catch (error) {
      console.error("Error in handleMilestoneDataAndEmailSubmission:", error);
    }
  };

  const validateName = (value) => {
    const re = /^[a-zA-Z.,]+$/;
    return re.test(String(value));
  };

  const validateCompany = (value) => {
    const re = /^[a-zA-Z0-9., ]+$/;
    return re.test(String(value));
  };

  const Capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleFirstNameChange = (e, limit) => {
    const val = e.target.value;
    if (val?.length <= limit) {
      setPodFirstName(Capitalize(val));
      if (val?.length > 0) {
        const validity = validateName(val);
        setIsFirstNameValid(validity);
      } else {
        setIsFirstNameValid(null);
      }
    }
  };

  const handleLastNameChange = (e, limit) => {
    const val = e.target.value;
    if (val?.length <= limit) {
      setPodLastName(Capitalize(val));
      if (val?.length > 0) {
        const validity = validateName(val);
        setIsLastNameValid(validity);
      } else {
        setIsLastNameValid(null);
      }
    }
  };

  const handleCompanyNameChange = (e, limit) => {
    const val = e.target.value;
    if (val?.length <= limit) {
      setPodCompanyName(Capitalize(val));
      if (val?.length > 0) {
        const validity = validateCompany(val?.trim());
        setIsCompanyNameValid(validity);
      } else {
        setIsCompanyNameValid(null);
      }
    }
  };

  const handleRemarkChange = (e) => {
    const val = e.target.value;
    setNote(val);
    if (val?.length > 0) {
      setIsNoteValid(true);
    } else {
      setIsNoteValid(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-sm">
      {afterAPIUpdatesModal === true && (
        <MileStoneModal
          moveToNextMilestone={moveToNextMilestone}
          newOverviewData={newOverviewData}
          emailStatus={emailStatus}
          submitStatus={submitStatus}
        />
      )}
      <div className="py-5 flex gap-2.5 items-baseline">
        <p className="font-bold text-gray-500">
          {capitalizeFirstLetter(
            selectedAogMilestoneObject?.[currentStep]?.phase,
          ) + " Stage"}
        </p>
        <p className="text-xs text-gray-400">#{overviewData?.uniqueId}</p>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg mb-6 flex flex-col gap-5">
        <div className="flex justify-between items-center border-b border-b-gray-200   p-4">
          <div className="flex items-center">
            <MilestoneIcon className="w-5 h-5 mr-2 text-gray-500" />
            <span className="font-bold text-sm text-gray-500">Milestones</span>
          </div>
          <span className="text-xs text-gray-500 bg-gray-50 px-2 py-1 rounded-xl">
            {currentStep < 9 ? `0${currentStep + 1}` : currentStep + 1} of{" "}
            {selectedAogMilestoneObject.length < 9
              ? `0${selectedAogMilestoneObject.length}`
              : selectedAogMilestoneObject.length}
          </span>
        </div>

        <div className="bg-primary-50 rounded-md p-3 mx-4">
          <div className="flex items-center  mb-1.5">
            <span className="mr-2">{milestoneTitleIcon()}</span>
            <span className="text-xs font-bold font-gray-500">
              {selectedAogMilestoneObject?.[currentStep]?.title}
            </span>
          </div>
          <p className="text-sm text-gray-400">
            {selectedAogMilestoneObject?.[currentStep]?.description}
          </p>
        </div>

        {/* company input  */}
        {(selectedAogMilestoneObject?.[currentStep]?.obc_remark ===
          "mandatory" ||
          selectedAogMilestoneObject?.[currentStep]?.obc_remark ===
            "optional") && (
          <div className="px-4">
            <InputwithLabelandError
              value={note}
              onChange={(e) => handleRemarkChange(e)}
              isError={
                selectedAogMilestoneObject?.[currentStep]?.obc_remark ===
                  "mandatory" && !isNoteValid
              }
              label="Add note"
              type="text"
              isValid={
                selectedAogMilestoneObject?.[currentStep]?.obc_remark ===
                  "mandatory" && !isNoteValid
              }
              isMandatory={
                selectedAogMilestoneObject?.[currentStep]?.obc_remark ===
                "mandatory"
              }
            />
          </div>
        )}
        {selectedAogMilestoneObject?.[currentStep]?.is_pod ? (
          <div className="px-4">
            {!isCompanyNameValid ? (
              <div className="bg-customError-100 ring-1 ring-customError-200 rounded-md p-3 mb-4">
                <p className="text-sm font-semibold text-customError-500">
                  {
                    "Invalid Input - Text, numbers and special characters ‘.’ and ',’ allowed. "
                  }
                </p>
              </div>
            ) : !isFirstNameValid || !isLastNameValid ? (
              <div className="bg-customError-100 ring-1 ring-customError-200 rounded-md p-3 mb-4">
                <p className="text-sm font-semibold text-customError-500">
                  {"Text only. No special characters or numbers."}
                </p>
              </div>
            ) : (
              ""
            )}
            <InputwithLabelandError
              value={podFirstName}
              onChange={(e) => handleFirstNameChange(e, 50)}
              isError={!isFirstNameValid}
              label="Receiver's First Name"
              type="text"
              isValid={isFirstNameValid}
              isMandatory={true}
            />
            <InputwithLabelandError
              value={podLastName}
              onChange={(e) => handleLastNameChange(e, 50)}
              isError={!isLastNameValid}
              label="Receiver's Last Name"
              type="text"
              isValid={isLastNameValid}
              isMandatory={true}
            />
            <InputwithLabelandError
              value={podCompanyName}
              onChange={(e) => handleCompanyNameChange(e, 100)}
              isError={!isCompanyNameValid}
              label="Receiver's Company Name"
              type="text"
              isValid={isCompanyNameValid}
              isMandatory={true}
            />
            <div className="mt-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-500">
                  Receiver Signature
                </span>
                <span className="text-xs text-gray-400">Required</span>
              </div>
              <canvas
                ref={canvasRef}
                className="w-full h-[180px] rounded-lg border border-dashed border-gray-300 bg-white"
              />
              <div className="flex gap-2 mt-3">
                <button
                  type="button"
                  className="px-4 py-2 text-sm rounded-md border border-gray-200 text-gray-500"
                  onClick={() => {
                    clearSignature();
                    deleteSignatureFile();
                  }}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="px-4 py-2 text-sm rounded-md bg-primary-500 text-white disabled:opacity-50"
                  onClick={uploadSignature}
                  disabled={signatureUploadStatus === "loading"}
                >
                  {signatureUploadStatus === "loading"
                    ? "Uploading..."
                    : signatureDetails?.key
                      ? "Re-upload Signature"
                      : "Save Signature"}
                </button>
              </div>
              {!signatureDetails?.key && (
                <p className="text-xs text-gray-400 mt-2">
                  Draw the receiver's signature and save it before submission.
                </p>
              )}
              {signatureDetails?.key && (
                <p className="text-xs text-green-600 mt-2">
                  Signature saved as {signatureDetails?.name}.
                </p>
              )}
              {signatureUploadStatus === "failed" && (
                <p className="text-xs text-customError-500 mt-2">
                  Signature upload failed. Please try again.
                </p>
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="">
          <p className="text-sm text-gray-400 ">
            {selectedAogMilestoneObject?.[currentStep]?.documents?.[0]
              ?.is_mandatory ? (
              <div className="pr-4 pl-4 border-b border-b-gray-200">
                <span className="text-base font-bold text-gray-500 ">
                  {selectedAogMilestoneObject?.[currentStep]?.pictureLabel}
                </span>
                <br />
                <span>
                  {
                    selectedAogMilestoneObject?.[currentStep]
                      ?.pictureDescription
                  }
                </span>
              </div>
            ) : (
              ""
            )}
          </p>
        </div>

        {selectedAogMilestoneObject?.[currentStep]?.documents.map(
          (doc, index) => (
            <div key={index} className="pr-4 pl-4 border-b border-b-gray-200">
              {doc?.is_mandatory ? (
                <>
                  <div className="mb-2">
                    <span className="text-base font-bold text-gray-500">
                      {doc?.label}
                    </span>
                    <p className="text-sm text-gray-400">{doc?.description}</p>
                  </div>

                  <Upload
                    document={doc}
                    bgColor={"bg-gray-25"}
                    imgBgColor={"bg-[#FAFCFF]"}
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                    id={overviewData?.uniqueId}
                    currentStep={`${currentStep + 1}_${index}`}
                    smartSheetLinks={smartSheetLinks}
                    setSmartSheetLinks={setSmartSheetLinks}
                    fileUploads={fileUploads}
                    setFileUploads={setFileUploads}
                  />
                </>
              ) : (
                <Accordion
                  heading={doc?.label}
                  subHeading={doc?.description}
                  expandIcon={expandIcon}
                  collapseIcon={collapseIcon}
                >
                  <Upload
                    document={doc}
                    bgColor={"bg-white"}
                    imgBgColor={"bg-white"}
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                    id={overviewData?.uniqueId}
                    currentStep={`${currentStep + 1}_${index}`}
                    smartSheetLinks={smartSheetLinks}
                    setSmartSheetLinks={setSmartSheetLinks}
                    fileUploads={fileUploads}
                    setFileUploads={setFileUploads}
                  />
                </Accordion>
              )}
            </div>
          ),
        )}

        <div className="p-4 pt-0 flex justify-between gap-2">
          {!selectedAogMilestoneObject?.[currentStep]?.is_mandatory && (
            <Button
              isPrimary={false}
              text={"Skip"}
              size={"md"}
              loading={submitLoading}
              onClick={() => handleMilestoneDataAndEmailSubmission(true)}
            />
          )}
          <Button
            text={"Submit"}
            size={"md"}
            loading={submitLoading}
            onClick={() => {
              setIsModalOpen(true);
            }}
            disabled={isDisabled()}
          />

          <Modal
            isOpen={isModalOpen || (submitLoading && !skipped)}
            header={"Confirm Submission"}
            message={
              "After each milestone is completed, an email will be sent to both the customer and the operations manager. Are you sure you want to submit?"
            }
            isCross={true}
            crossAction={() => setIsModalOpen(false)}
            buttonTitle={"Confirm"}
            submitStatus={submitStatus}
            emailStatus={emailStatus}
            submitAttempts={submitAttempts} // Tracks retry count for milestone update
            emailAttempts={emailAttempts} // Tracks retry count for email update
            maxRetries={MAX_RETRIES}
            closeModal={() => setIsModalOpen(false)}
            retrySubmission={retrySubmission}
            milestoneNo={currentStep + 1}
            milestoneDescription={
              selectedAogMilestoneObject?.[currentStep]?.title
            }
            moveToNextMilestone={moveToNextMilestone}
            MAX_RETRIES={MAX_RETRIES}
            cooldownTime={cooldownTime}
            isCooldownActive={isCooldownActive}
            isGround={isGround}
            currentStep={currentStep}
            setIsSuccess={setIsSuccess}
            // function to submit the current details

            buttonAction={handleMilestoneDataAndEmailSubmission}
            isLoading={submitLoading}
            loadingMessage={
              "Recording your progress and preparing your next milestone."
            }
            isSuccess={isSuccess}
            successHeader={
              selectedAogMilestoneObject[currentStep - 1]?.phase +
              " Stage Completed!"
            }
            successMessage={
              selectedAogMilestoneObject?.[currentStep - 1]?.phase ===
              "delivery"
                ? "Congratulations! All stages completed. Shipment successfully delivered."
                : `Great job! ${
                    selectedAogMilestoneObject?.[currentStep - 1]?.phase
                  } Stage milestones finished. Next Stage: ${selectedAogMilestoneObject?.[
                    currentStep
                  ]?.phase.replace("Phase", "Stage")}.`
            }
            successButton={
              selectedAogMilestoneObject?.[currentStep - 1]?.phase ===
              "delivery"
                ? "Complete Shipment"
                : "Next Stage"
            }
            // function to navigate to next page or step 2

            successButtonAction={async () => {
              // Make the function async
              setIsModalOpen(false);
              setIsSuccess(false);

              if (
                selectedAogMilestoneObject?.filter(
                  (milestone) =>
                    milestone.status === "pending" ||
                    milestone.status === "in-progress",
                )?.length === 0
              ) {
                setSubmitLoading(true);
                setLoading(true);

                try {
                  const attachmentsData = await getDownloadAllUrls(
                    `${encodeURIComponent(overviewData?.uniqueId)}/`,
                  );
                  const updatedData = await handleSubmit({
                    updateData: {
                      stageData: {
                        end_date: new Date().toISOString(),
                        location_updates: [
                          ...overviewData?.stages?.[0]?.location_updates,
                          {
                            milestone: "End Assignment",
                            location: `https://www.google.com/maps?q=${coordRef.current?.latitude}%2C${coordRef.current?.longitude}`,
                          },
                        ],
                        stage_status: "Completed",
                      },
                      last_updated_by: userEmail,
                    },
                  });

                  await sendMilesStoneUpdateEmail({
                    emailData: {
                      customerName: updatedData.data[0]?.customer_id?.name,
                      status: "Shipment Completed",
                      currentTime: new Date().toUTCString(),
                      assignmentId: updatedData.data[0]?.uniqueId,
                      previousMilestones:
                        updatedData.data[0]?.stages?.[0]?.milestones,
                      emailTo:
                        updatedData.data[0]?.customer_id?.updateEmailPrimary,
                      emailCc:
                        updatedData.data[0]?.customer_id?.updateEmailSecondary?.join(
                          ",",
                        ),
                      emailBcc:
                        updatedData.data[0]?.customer_id?.updateEmailOthers?.join(
                          ",",
                        ),
                      podFirstName: updatedData.data[0]?.pod?.first_name,
                      podLastName: updatedData.data[0]?.pod?.last_name,
                      podCompanyName: updatedData.data[0]?.pod?.company,
                      attachments: attachmentsData,
                      totalMilestones: selectedAogMilestoneObject?.length,
                    },
                  });

                  setIsModalOpen(false);
                  setLoading(false);
                  setStatus(
                    currentStep < selectedAogMilestoneObject?.length
                      ? "milestone"
                      : "completed",
                  );
                  if (currentStep >= selectedAogMilestoneObject?.length)
                    setFetchLatestData(true);

                  // Move navigation inside the try block to ensure it's only triggered after all steps are completed
                  navigate(
                    currentStep >= selectedAogMilestoneObject?.length
                      ? `/home/${overviewData?.uniqueId}/completed`
                      : `/home/${overviewData?.uniqueId}/milestone?m=${
                          currentStep + 1
                        }`,
                  );
                } catch (error) {
                  console.error("Error in successButtonAction:", error);
                  setSubmitLoading(false);
                  setLoading(false);
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};
